import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const DocumentationTranslationKeys = {
  createDirectory: translationKey('create_directory'),
  createDocumentation: translationKey('create_documentation'),
  directoryNameFieldLabel: translationKey('directory_name_field_label'),
  documentLinkExpiredInfo: translationKey('document_link_expired_info'),
  author: translationKey('documentation_author'),
  breadcrumbExpandHint: translationKey('documentation_breadcrumb_expand_hint'),
  columnLabelCountRelatedIssues: translationKey('documentation_column_label_count_related_issues'),
  columnLabelCreatedAt: translationKey('documentation_column_label_created_at'),
  columnLabelCreatedBy: translationKey('documentation_column_label_created_by'),
  columnLabelDirectory: translationKey('documentation_column_label_directory'),
  columnLabelExportedFromIssue: translationKey('documentation_column_label_exported_from_issue'),
  columnLabelLevel: translationKey('documentation_column_label_level'),
  columnLabelModifiedAt: translationKey('documentation_column_label_modified_at'),
  columnLabelModifiedBy: translationKey('documentation_column_label_modified_by'),
  columnLabelName: translationKey('documentation_column_label_name'),
  columnLabelNumber: translationKey('documentation_column_label_number'),
  columnLabelSite: translationKey('documentation_column_label_site'),
  columnLabelState: translationKey('documentation_column_label_state'),
  creationDate: translationKey('documentation_creation_date'),
  directoryContainsMatchingFiles: translationKey('documentation_directory_contains_matching_files'),
  dropFilesToDirectory: translationKey('documentation_drop_files_to_directory'),
  dropFilesToMoveToDirectory: translationKey('documentation_drop_files_to_move_to_directory'),
  emptyInfo: translationKey('documentation_empty_info'),
  fileNotSupportedAsMap: translationKey('documentation_file_not_supported_as_map'),
  fileNotUsedAsMap: translationKey('documentation_file_not_used_as_map'),
  filterAction: translationKey('documentation_filter_action'),
  filteringUnavailable: translationKey('documentation_filtering_unavailable'),
  goToSourceIssueAction: translationKey('documentation_go_to_source_issue_action'),
  hideIssuesAction: translationKey('documentation_hide_issues_action'),
  itemFolderCountSuffix: translationKey('documentation_item_folder_count_suffix'),
  itemFolderWithCount: translationKey('documentation_item_folder_with_count'),
  nameFieldLabel: translationKey('documentation_name_field_label'),
  numberFieldLabel: translationKey('documentation_number_field_label'),
  progressPanelPin: translationKey('documentation_progress_panel_pin'),
  progressPanelUnpin: translationKey('documentation_progress_panel_unpin'),
  returnToSearch: translationKey('documentation_return_to_search'),
  returnToSearchTooltip: translationKey('documentation_return_to_search_tooltip'),
  searchNavigatedAway: translationKey('documentation_search_navigated_away'),
  showIssuesAction: translationKey('documentation_show_issues_action'),
  sourceIssueMissingTooltip: translationKey('documentation_source_issue_missing_tooltip'),
  stateArchived: translationKey('documentation_state_archived'),
  statePublished: translationKey('documentation_state_published'),
  useAsMap: translationKey('documentation_use_as_map'),
  documentsAddMediaButtonSubtitle: translationKey('documents_add_media_button_subtitle'),
  editDirectory: translationKey('edit_directory'),
  folderUploadCreatingFolders: translationKey('folder_upload_creating_folders'),
  newDirectory: translationKey('new_directory'),
  uploadDirectory: translationKey('upload_directory'),
  uploadFiles: translationKey('upload_files'),
} as const satisfies Record<string, TranslationKey>;
